class GLRaycastDebugCanvas {
    constructor() {
        this._canvas = document.createElement("canvas");
        this._context = this._canvas.getContext("2d");
        this._imgData = null;
        this._updateThis = this._bufferUpdated.bind(this);

        Object.assign(this._canvas.style, {
            position: "absolute",
            left: 0,
            top: 0,
            pointerEvents: "none",
        });

        this._glraycastBuffer = null;
    }

    get canvas() {
        return this._canvas;
    }

    start(glraycastBuffer) {
        this._glraycastBuffer = glraycastBuffer;
        glraycastBuffer.listenUpdate(this._updateThis);
    }

    stop() {
        this._glraycastBuffer.unlistenUpdate(this._updateThis);
    }

    _bufferUpdated(glraycastBuffer) {
        const { width: curWidth, height: curHeight } = this._canvas;

        const bufData = glraycastBuffer.data;

        if (bufData) {
            const { width, height } = bufData;

            if (width !== curWidth || height !== curHeight) {
                this._canvas.width = width;
                this._canvas.height = height;

                this._imgData = new ImageData(width, height);
            }

            const imgData = this._imgData;

            const rowSize = width*4;
            const bufSize = height*rowSize;

            let imgPos = bufSize;
            for (let bufPos = 0; bufPos < bufSize; bufPos += rowSize) {
                imgPos -= rowSize;

                for (let off = 0; off < rowSize; off++) {
                    imgData.data[imgPos+off] = bufData.pixels[bufPos+off];
                }
            }

            this._context.putImageData(imgData, 0, 0);
        } else {
            this._imgData = null;
            this._context.clearRect(0, 0, curWidth, curHeight);
        }
    }
}

export default GLRaycastDebugCanvas;
